module.exports = __webpack_public_path__ + "static/channel_mgr_diagram-2de02a4f9c6eaae7e3d4ca7810722727.svg";